export default "__VITE_ASSET__Cu2TvY3$__"